(() => {
  const root = document.getElementById('mse-q4-upsell');
  if (!root) return;

  const threshold = Number(root.dataset.threshold || 8995);
  const discountCode = root.dataset.discountCode || '';
  const status = root.querySelector('[data-mse-upsell-status]');
  const addButtons = [...root.querySelectorAll('[data-mse-upsell-add]')];
  const productRail = root.querySelector('[data-mse-upsell-products]');
  let cartToken = '';
  let lastFocus = null;
  let busy = false;

  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
  const addUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
  const checkoutUrl = `${window.Shopify?.routes?.root || '/'}checkout`;
  const discountCheckoutUrl = () => `${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/checkout')}`;

  const fetchCart = async () => {
    const response = await fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };

  const hasMarkedUpsell = (cart) => (cart.items || []).some((item) => item.properties && String(item.properties._myromy_q4_upsell) === '1');
  const declinedKey = (token) => `mse:q4:upsell:declined:${token || 'cart'}`;

  const prioritizeEdition = (cart) => {
    if (!productRail) return;
    const cartText = (cart.items || []).map((item) => `${item.handle || ''} ${item.product_title || ''} ${item.variant_title || ''}`).join(' ').toLowerCase();
    const preferredEdition = cartText.includes('coffee') ? 'coffee' : 'signature';
    const cards = [...productRail.querySelectorAll('[data-mse-upsell-card]')];
    cards.sort((a, b) => Number(b.dataset.edition === preferredEdition) - Number(a.dataset.edition === preferredEdition));
    cards.forEach((card) => productRail.appendChild(card));
    productRail.scrollLeft = 0;
    root.dataset.preferredEdition = preferredEdition;
  };

  const open = (cart) => {
    cartToken = cart.token || '';
    lastFocus = document.activeElement;
    status.textContent = '';
    prioritizeEdition(cart);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mse-q4-upsell-open');
    window.setTimeout(() => root.querySelector('[data-mse-upsell-close]')?.focus(), 0);
  };

  const close = () => {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mse-q4-upsell-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const goCheckout = (withDiscount = false) => {
    window.location.assign(withDiscount && discountCode ? discountCheckoutUrl() : checkoutUrl);
  };

  const handleCheckoutIntent = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetchCart();
      const alreadyUpsell = hasMarkedUpsell(cart);
      const declined = sessionStorage.getItem(declinedKey(cart.token)) === '1';

      if (alreadyUpsell) {
        goCheckout(true);
        return;
      }

      if (Number(cart.items_subtotal_price || 0) >= threshold && !declined && addButtons.length > 0) {
        open(cart);
        return;
      }

      goCheckout(false);
    } catch (_) {
      goCheckout(false);
    } finally {
      busy = false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.querySelector('[name="checkout"]')) return;
    if (event.submitter && event.submitter.getAttribute('name') !== 'checkout') return;
    event.preventDefault();
    handleCheckoutIntent();
  }, true);

  document.addEventListener('click', (event) => {
    const checkoutLink = event.target.closest?.('a[href*="/checkout"]');
    if (!checkoutLink || checkoutLink.closest('#mse-q4-upsell')) return;
    event.preventDefault();
    handleCheckoutIntent();
  }, true);

  root.addEventListener('click', async (event) => {
    const closeButton = event.target.closest('[data-mse-upsell-close]');
    if (closeButton) {
      close();
      return;
    }

    const skipButton = event.target.closest('[data-mse-upsell-skip]');
    if (skipButton) {
      try { sessionStorage.setItem(declinedKey(cartToken), '1'); } catch (_) {}
      goCheckout(false);
      return;
    }

    const addButton = event.target.closest('[data-mse-upsell-add]');
    if (!addButton || busy) return;

    const variantId = Number(addButton.dataset.variantId || 0);
    if (!variantId) return;

    busy = true;
    root.classList.add('is-loading');
    addButtons.forEach((button) => { button.disabled = true; });
    status.textContent = '';

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _myromy_q4_upsell: '1' } }] })
      });
      if (!response.ok) throw new Error('Add failed');
      goCheckout(true);
    } catch (_) {
      status.textContent = 'Das Hinzufügen hat nicht geklappt. Bitte versuche es noch einmal.';
      busy = false;
      root.classList.remove('is-loading');
      addButtons.forEach((button) => { button.disabled = false; });
    }
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();
